module.exports = __webpack_public_path__ + "static/media/credit_card_cvc-2.3a732f78.png";